import React, { useCallback, useState } from 'react';
import { Printer } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import { DialogTitle } from 'shadcn/components/ui/Dialog';

import { PrintAllocatedLabelsSummaryCard } from './PrintAllocatedLabelsSummaryCard';
import { DEFAULT_TAGS_PER_PALLET, getLineItemDisplayFields, sanitizeTagsPerPalletInput } from './printLabelsUtils';
import { PrintPalletCaseTags } from './PrintPalletCaseTags';
import { PrintPalletTagsCard } from './PrintPalletTagsCard';

function handlePrintAllLabels() {
    // TODO: print all labels
}

function handlePrintAllPalletTags() {
    // TODO: print all pallet tags
}

/**
 * @param {Object} props
 * @param {boolean} [props.isFbmMode]
 * @param {string} props.poType
 * @param {string | null} [props.partnerDisplayName]
 * @param {object} props.receivedPrintData
 * @param {object} props.rowData
 */
function PrintAllocatedLabelsModal({
    isFbmMode = false,
    partnerDisplayName = null,
    poType,
    receivedPrintData,
    rowData,
}) {
    const { itemName, sku, unitsPerCase } = getLineItemDisplayFields(rowData, poType);
    const [tagsPerPallet, setTagsPerPallet] = useState(DEFAULT_TAGS_PER_PALLET);
    const numPallets = receivedPrintData.pallets.length;

    const handleTagsPerPalletChange = useCallback((event) => {
        setTagsPerPallet(sanitizeTagsPerPalletInput(event.target.value));
    }, []);

    return (
        <>
            <div className="flex items-center justify-between gap-4 border-b py-4 pl-6 pr-12">
                <DialogTitle className="p-0 text-base font-semibold">Print Labels</DialogTitle>
                <Button
                    className="bg-[#4C884B] text-white hover:bg-[#4C884B]/90"
                    type="button"
                    onClick={handlePrintAllLabels}
                >
                    <Printer aria-hidden className="size-4" />
                    Print All Labels
                </Button>
            </div>
            <div className="p-6">
                <PrintAllocatedLabelsSummaryCard
                    itemName={itemName}
                    numPallets={numPallets}
                    sku={sku}
                    totalCases={receivedPrintData.totalCases}
                    unitsPerCase={unitsPerCase}
                />
                <PrintPalletTagsCard
                    className="mt-4"
                    numPallets={numPallets}
                    tagsPerPallet={tagsPerPallet}
                    onPrintAllPalletTags={handlePrintAllPalletTags}
                    onTagsPerPalletChange={handleTagsPerPalletChange}
                />
                <div className="mt-6 flex items-center gap-3">
                    <div className="h-px flex-1 bg-border" />
                    <span className="text-xs font-medium tracking-wide text-muted-foreground uppercase">
                        Per-Pallet Breakdown
                    </span>
                    <div className="h-px flex-1 bg-border" />
                </div>
                <div className="mt-3 flex max-h-[min(50vh,28rem)] flex-col gap-2 overflow-y-auto">
                    {receivedPrintData.pallets.map((pallet, index) => (
                        <PrintPalletCaseTags
                            key={pallet.id}
                            isFbmMode={isFbmMode}
                            pallet={pallet}
                            palletIndex={index}
                            partnerDisplayName={partnerDisplayName}
                            tagsPerPallet={tagsPerPallet}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}

export { PrintAllocatedLabelsModal, handlePrintAllLabels, handlePrintAllPalletTags };
